import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const driverApi = axios.create({ baseURL: API });

driverApi.interceptors.request.use((config) => {
  const token = localStorage.getItem("juke_driver_token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export default driverApi;
